import PrismAPI from '@modules/prism-client/types/prism-types';
import { FC } from 'react';
import { ImageProps, Image } from '@tuic/web-compositions/shared/Image';
import { AssetRatio, transformAssetToImageProps } from '@modules/prism-client/lib/asset-to-image-props';
type Props = {
  data: PrismAPI.Asset;
  ratio?: AssetRatio;
} & Omit<ImageProps, 'src' | 'alt' | 'description'>;
export const Asset: FC<Props> = ({
  data,
  ratio,
  ...props
}) => {
  const assetToImageProps = transformAssetToImageProps(data, {
    ratio
  });
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <Image {...props} {...assetToImageProps} sizes={props.sizes ?? assetToImageProps.sizes} data-sentry-element="Image" data-sentry-component="Asset" data-sentry-source-file="Asset.tsx" />
  );
};